export default "__VITE_ASSET__BzGctXPq__"